import { EmailArtifactLocation } from '@amazon-connect/email';
import config from '../config';

export const fetchEmailBody = async (
  bodyLocation: EmailArtifactLocation,
  contactId: string
): Promise<string | undefined> => {
  const apiUrl = config.emailApiUrl;

  if (!apiUrl) {
    throw new Error('Email API Url is not configured');
  }

  const params = new URLSearchParams({ fileId: bodyLocation.fileId, contactId });
  const response = await fetch(`${apiUrl}/body?${params.toString()}`, {
    method: 'GET'
  });

  if (!response.ok) throw new Error(`API responded with status ${response.status}`);

  const json = (await response.json()) as {
    meta: { version: string };
    data: { body: string; ccAddresses: string[] };
  };

  return json.data.body;
};
